/** @jsx jsx */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { FC } from 'react';
import { jsx } from '@emotion/core';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'reducers/mainReducer';
import { useDocument } from 'react-firebase-hooks/firestore';
import firebase, { db } from 'firebase/Instances';
import { commonActions } from 'actions/common/common';

import { subscribeCanvasMembers } from 'actions/call/workboard';

export const CanvasListener: FC = () => {
  const roomId = useSelector<RootState, string>(state => state.workboard.roomId);
  const currentMembers = useSelector<RootState, string[]>(state => state.workboard.canvasTmpData.members);
  const dispatch = useDispatch();

  const [members, loading, error] = useDocument(
    db
      .collection('workboards')
      .doc(roomId)
      .collection('canvases')
      .doc('members'),
  );

  if (loading) {
    return <div />;
  }

  if (error) {
    dispatch(commonActions.error('ワークボード参加メンバー情報の取得に失敗しました。'));
  }

  if (members && members?.exists) {
    const membersDoc = members.data() as firebase.firestore.DocumentData;
    const memberList: string[] = membersDoc.members;
    if (memberList.length !== currentMembers.length) {
      dispatch(subscribeCanvasMembers(memberList));
    }
  }

  return <div />;
};
